/*@ngInject*/
const ChatController = function ($rootScope, $scope, $state, $q, localization, coreConstant, coreMediator, currentUserModel, currentSubmissionModel, chatNotificationModel, notificationType, submissionStateMediator, submissionConstant, preferenceModel) {

    const openingSubmissionFromNotificationMarksNotificationAsReadPreference = preferenceModel.get('system.openingSubmissionFromNotificationMarksNotificationAsRead');
    const openingSubmissionFromNotificationMarksNotificationAsRead = openingSubmissionFromNotificationMarksNotificationAsReadPreference === 'true' || _.isNil(openingSubmissionFromNotificationMarksNotificationAsReadPreference);

    localization.setupLocale('chatNotification', require('./chatNotification.i18n.json'));

    this.isOpen = false;
    this.chatNotificationModel = chatNotificationModel;
    this.limit = coreConstant.chatNotifications.loadLimit;
    this.limitIncrement = coreConstant.chatNotifications.loadLimit;
    this.userId = currentUserModel.getCurrentUser().userId;
    this.disableLoadMore = false;
    this.numberOfUnacknowledged = 0;
    this.numberOfUnread = 0;
    this.tooltip = i18n.t('chatNotification|chatNotification.tooltip');
    this.markAsReadTooltip = i18n.t('chatNotification|chatNotification.popout.markAsRead');
    this.markAsUnreadTooltip = i18n.t('chatNotification|chatNotification.popout.markAsUnread');
    this.controlsVisible = {};
    this.chatNotificationTooltips = {};
    this.unreadLabel = i18n.t('chatNotification|chatNotification.popout.unread');
    this.isLoading = false;
    this.isLoadingMore = false;

    this.init = function () {
        const isLoadingMore = false;

        if (!chatNotificationModel.areNotificationsPopulated()) {
            this.getNotifications(isLoadingMore);
        }
        this.getCounts();
    };

    this.onIconClick = function () {
        this.isOpen = !this.isOpen;
        if (!this.isOpen) {
            this.numberOfUnacknowledged = 0;
            this.disableLoadMore = false;
            coreMediator.acknowledgeByUserId(this.userId, notificationType.CHAT);
        } else {
            this.controlsVisible = {};
            this.chatNotificationTooltips = {};

            if (this.limit >= chatNotificationModel.getNotifications().length) {
                this.disableLoadMore = true;
            }
        }
    };

    this.onLoadMoreClick = function () {
        const isLoadingMore = true;

        if (!this.disableLoadMore) {
            this.limit += this.limitIncrement;
            this.getNotifications(isLoadingMore);
        }
    };

    this.onInsuredNameClick = function (notification) {
        let promise;

        if (notification.read) {
            promise = $q.when();
        } else {
            if (openingSubmissionFromNotificationMarksNotificationAsRead) {
                promise = coreMediator.markAsReadByNotificationId(notification.id, true);
            } else {
                promise = $q.when();
            }
        }

        promise.then(() => {
            let params = {submissionId: notification.submissionId},
                stateName = 'submission.form';

            this.onIconClick();

            if (_.isNil(currentSubmissionModel.getCurrentSubmission()) || currentSubmissionModel.getSelectedSubmission().id !== notification.submissionId) {
                submissionStateMediator.openChatCollaboration(notification.submissionId);
                $state.go(stateName, params);
            } else {
                $rootScope.$broadcast(submissionConstant.event.OPEN_CHAT_COLLABORATION);
            }
        });
    };

    this.getNotificationActor = function (notification) {
        const actorName = notification.actorName === 'AUTHENTICATION_SERVER' ? 'System' : notification.actorName;
        return actorName;
    };

    this.getNotifications = function (isLoadingMore) {
        if (isLoadingMore) {
            this.isLoadingMore = true;
        } else {
            this.isLoading = true;
        }

        coreMediator.resetUserNotificationRegistrations(notificationType.CHAT).finally(() => {
            const latest = true;
            const unreadOnly = this.isFilterSelected(coreConstant.chatNotifications.filters.UNREAD);

            coreMediator.findByNotifiedUserId(this.userId, notificationType.CHAT, 0, this.limit + this.limitIncrement, latest, unreadOnly).then((notifications) => {
                if (this.limit >= notifications.length) {
                    this.disableLoadMore = true;
                }
                chatNotificationModel.setNotifications(notifications);
            }).finally(() => {
                this.isLoading = false;
                this.isLoadingMore = false;
            });
        });
    };

    this.getCounts = function () {
        const latest = true;

        coreMediator.countUnacknowledgedByUserId(this.userId, notificationType.CHAT, latest).then((numberOfUnacknowledged) => {
            this.numberOfUnacknowledged = numberOfUnacknowledged;
        });

        coreMediator.countUnreadByUserId(this.userId, notificationType.CHAT, latest).then((numberOfUnread) => {
            this.numberOfUnread = numberOfUnread;
        });
    };

    this.isFilterSelected = function (filter) {
        return chatNotificationModel.getSelectedFilter() === filter;
    };

    this.selectFilter = function (filter) {
        const isLoadingMore = false;

        if (chatNotificationModel.getSelectedFilter() !== filter) {
            chatNotificationModel.setSelectedFilter(filter);

            this.limit = coreConstant.chatNotifications.loadLimit;
            this.disableLoadMore = false;
            this.getNotifications(isLoadingMore);
        }
    };

    this.areAllNotificationsRead = function () {
        return this.numberOfUnread === 0;
    };

    this.markAllAsRead = function () {
        if (!this.areAllNotificationsRead()) {
            // set local notifications as read
            this.numberOfUnread = 0;
            _.each(chatNotificationModel.getNotifications(), (notification) => {
              notification.read = true;
            });
            // call backend
            coreMediator.markAllAsReadByUserId(this.userId, notificationType.CHAT).then(() => {
                coreMediator.acknowledgeByUserId(this.userId, notificationType.CHAT);
            });
        }
    };

    this.showControls = function (notification) {
        this.controlsVisible[notification.id] = true;
    };

    this.hideControls = function (notification) {
        this.controlsVisible[notification.id] = false;
    };

    this.areControlsVisible = function (notification) {
        return this.controlsVisible[notification.id];
    };

    this.getMarkAsReadTooltip = function (notification) {
        let tooltip;

        if (notification.read) {
            tooltip = this.markAsUnreadTooltip;
        } else {
            tooltip = this.markAsReadTooltip;
        }

        return tooltip;
    };

    this.toggleRead = function (notification) {
        const hideControls = this.isFilterSelected(coreConstant.chatNotifications.filters.UNREAD);

        coreMediator.markAsReadByNotificationId(notification.id, notification.read).then(() => {
            if (!notification.acknowledged) {
                coreMediator.acknowledgeByNotificationId(notification.id);
            }

            if (hideControls) {
                this.hideControls(notification);
            }
        });
    };

    this.getUnreadNotificationsCount = function () {
        return `${this.numberOfUnread} ${this.unreadLabel}`;
    };

    this.shouldShowUnreadNotificationsCount = function () {
        return this.numberOfUnread > 0;
    };

    this.shouldDisableLoadMore = function () {
        return this.disableLoadMore || this.isLoading || this.isLoadingMore;
    };

    $scope.$on(coreConstant.event.CREATE_NOTIFICATION, (event, notification) => {
        if (notificationType.CHAT === notification.type) {
            if ((this.isFilterSelected(coreConstant.chatNotifications.filters.UNREAD) && !notification.read) || this.isFilterSelected(coreConstant.chatNotifications.filters.ALL)) {
                chatNotificationModel.prependNotification(notification);
                if (chatNotificationModel.getNotifications().length > this.limit) {
                    this.disableLoadMore = false;
                }
                this.getCounts();
            }
        }
    });

    $scope.$on(coreConstant.event.UPDATE_NOTIFICATION, (event, notifications) => {
        let getCounts = false;

        _.each(notifications, (notification) => {
            const isLoadingMore = false;

            if (notificationType.CHAT === notification.type) {
                if (this.isFilterSelected(coreConstant.chatNotifications.filters.UNREAD) && notification.read) {
                    chatNotificationModel.removeNotification(notification);

                    if (chatNotificationModel.getNotifications().length === 0) {
                        this.getNotifications(isLoadingMore);
                    } else if (this.limit >= chatNotificationModel.getNotifications().length) {
                        this.disableLoadMore = true;
                    }
                } else {
                    chatNotificationModel.updateNotification(notification);
                }

                getCounts = true;
            }
        });

        if (getCounts) {
            this.getCounts();
        }
    });

    $scope.$on(coreConstant.event.LOGOUT_COMPLETE, function () {
        chatNotificationModel.clearNotifications();
        currentUserModel.clearRegistrations();
        currentUserModel.clearNotificationRegistrations();
    });

    this.init();
};

angular.module('ums')
    .controller('chatController', ChatController);
